import { FC } from 'react';
import classNames from 'classnames';
import SvgIcon from '../SvgIcon/SvgIcon';
import infoSvg from '../../images/message_icons/info.svg';
import securitySvg from '../../images/message_icons/lock.svg';
import warningSvg from '../../images/message_icons/warning.svg';
import errorSvg from '../../images/message_icons/danger.svg';

import styles from './MessageBlock.module.scss';
import TestIds from '../../tests/TestIds';

export enum BlockStyle {
	Fill = 'fill',
	Border = 'border',
}

export enum MessageType {
	Info = 'info',
	Security = 'security',
	Warning = 'warning',
	Error = 'error',
	Success = 'success',
}

const icons = {
	[MessageType.Info]: infoSvg,
	[MessageType.Security]: securitySvg,
	[MessageType.Warning]: warningSvg,
	[MessageType.Error]: errorSvg,
} as const;

type MessageBlockProps = {
	message: string;
	style: BlockStyle;
	type: MessageType;
	withIcon?: boolean;
};

const MessageBlock: FC<MessageBlockProps> = ({ message, style, type, withIcon, ...rest }) => {
	return (
		<div
			data-cy={TestIds.MessageBlock}
			{...rest}
			className={classNames(styles.container, styles[style], styles[type])}
		>
			{withIcon && icons[type as keyof typeof icons] && (
				<SvgIcon className={styles.icon} src={icons[type as keyof typeof icons]} />
			)}
			<div className={styles.message}>{message}</div>
		</div>
	);
};

export default MessageBlock;
